// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7c-0";
export var startPickingButton = "_7c-1";